import styled from 'styled-components';
import WhiteArrow from '../../images/managers/white_left_arrow.png';

export const BuildingItem = styled.div`
  margin-bottom: 1rem;
  .set_pr_link {
    position: relative;
    height: 52px;
    background: #fff;
    border: 1px solid var(--bllink-purple);
    border-radius: 50px;
    font-family: var(--bllink-font-primary);
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 46px;
    text-align: start;
    color: var(--bllink-gray);
    text-decoration: none;

    display: flex;
    flex-direction: row;    
    & > div {
      flex: 1 1 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:first-of-type, &:last-of-type {
        flex: 0 0 50px;
      }      
    }
  }
  .cl_img_link_2 {
    width: 50px;
    height: 50px;
    border-inline-end: 1px solid #6F8BFF;
    border-top: 1px solid #6F8BFF;
    border-bottom: 1px solid #6F8BFF;
    border-radius: 50%;
    margin-inline-end: 20px;
    img {
      padding-inline-start: 11px;      
      padding-bottom: 4px;
    }  
  }
  .cl_img_link_1 {
    width: 50px;
    height: 50px;
    border-inline-end: 1px solid #6F8BFF;
    border-top: 1px solid #6F8BFF;
    border-bottom: 1px solid #6F8BFF;
    border-radius: 50%;
    transition: background-color .25s ease-in;
    transform: rotate(${({ ltr }) => ltr ? '180deg' : '0deg'});
    img {      
      margin-inline-start: 20px;
    }
    &:hover {
      background-color: #7d74ff;
      background-repeat: no-repeat;
      background-image: url(${WhiteArrow});
      background-position: center;
      img {
        visibility: hidden;
      }
    }
  }
  .st_cl_sp {
    color: var(--bllink-gray);
  }
`;

export const BuildStructure = styled.div`
  border: 1px solid var(--bllink-blue);
  border-radius: 50px;
  width: 100%;
  max-width: 100%;
  margin-top: 40px;
  padding: 52px 30px;
  .block-title {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    color: var(--bllink-gray);
    margin-bottom: 25px;
  }
`;

export const AllBuildingsStyled = styled.section`
  .widgets-align {
    opacity: 0;
    height: 0;
    transition-timing-function: linear, step-end;
    &.visible {
      margin: 2rem 0;
      height: auto;
      opacity: 1;
      transition: opacity 1s linear, height 2s step-start;
    }
  }
  .search_build {
    h2 {
      font-family: var(--bllink-font-headers);
      font-size: 44px;
      line-height: 62px;
      text-align: center;
      color: var(--bllink-gray);
    }
    p {
      font-family: var(--bllink-font-primary);
      font-size: 18px;
      line-height: 23px;
      text-align: center;
      color: #6A697C;
      width: 100%;
      max-width: 470px;
      margin: 30px auto;
    }
  }

  #login_an_account {
    width: 270px;
    height: 52px;
    background: linear-gradient(87.88deg, #6B92FF 0%, #8764FF 100%);
    border-radius: 50px;
    display: block;
    font-family: var(--bllink-font-primary);
    font-weight: bold;
    font-size: 18px;
    line-height: 50px;
    text-align: center;
    color: #FFFFFF;
    margin: 40px auto;
    text-decoration: none;
  }
  
  .search-building {
    padding: 0;
    label {
      padding-right: 20px;
      font-family: var(--bllink-font-primary);
      font-size: 18px;
      line-height: 23px;
      text-align: start;
      color: var(--bllink-gray);
      width: 100%;
    }
    input {
      padding-right: 20px;
      height: 52px;
      background: #FFFFFF;
      border: 1px solid var(--bllink-blue);
      border-radius: 50px;
    }
  }

  #search_building_3 {
    width: 270px;
    height: 52px;
    border-radius: 50px;
    font-family: var(--bllink-font-primary);
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    text-align: center;
    color: var(--bllink-purple) !important;
    border: 1px solid var(--bllink-purple);
    margin-top: 33px;
    &:hover {
      color: #fff !important;
      background: var(--bllink-purple);
    }
  }

  @media screen and (max-width: 768px) {
    .open-building-btn {
      display: none;
    }
  }
`;
